"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewMerchant = void 0;
/*
 * @LastEditTime: 2022-07-14 22:59:16
 */
// 入驻
var base_1 = __importDefault(require("../../base"));
var page_config_1 = __importDefault(require("./page_config"));
// config
var BASE_URL = '/merchant-shop';
var MERCHANT_HOSTS = {
    production: "https://lbs.kuaishou.com".concat(BASE_URL),
    beta: "http://ll-mfe.staging.kuaishou.com".concat(BASE_URL),
};
// Merchant默认使用history方式跳转
var isHistory = true;
var createNewMerchant = function (jumpOptions) {
    jumpOptions.betaHost && (MERCHANT_HOSTS.beta = jumpOptions.betaHost);
    return new base_1.default({
        host: MERCHANT_HOSTS,
        bridgeQuery: __assign({
            layoutType: 4,
            enableWK: 1,
            hyId: 'ks-fe-ll-merchant',
        }, (jumpOptions.bridgeQuery || {})),
        history: jumpOptions.history || isHistory,
        pages: __assign(__assign({}, page_config_1.default), (jumpOptions.pages || {})),
        baseUrl: jumpOptions.baseUrl || BASE_URL,
    });
};
exports.createNewMerchant = createNewMerchant;
var merchant = new base_1.default({
    host: MERCHANT_HOSTS,
    bridgeQuery: {
        layoutType: 4,
        enableWK: 1,
        hyId: 'ks-fe-ll-merchant',
    },
    history: isHistory,
    pages: page_config_1.default,
    baseUrl: BASE_URL,
});
exports.default = merchant;
